import Vue from 'vue';
import { Component, Emit, Prop, Ref } from 'vue-property-decorator';
import AdvancedFilterSelection from '@/components/filters/AdvancedFilterSelection';
import FilterSelectOption from '@/components/filters/FilterSelectOption';



@Component({
  components: {
  },
  directives: {
  }
})
export default class AdvancedFiltersMenu extends Vue {
  @Prop({ default: () => [] }) private languages!: FilterSelectOption[];
  @Prop({ default: () => [] }) private services!: FilterSelectOption[];
  @Prop() private maxPrice!: number;
  @Prop() private minPrice!: number;

  @Ref('advanced-menu') menu!: any;

  mounted() {
    if (this.maxPrice) this.typedMaxPrice = this.maxPrice;
    if (this.minPrice) this.typedMinPrice = this.minPrice;
    this.menu.activatorFixed = true;
  }

  @Emit() apply(): AdvancedFilterSelection {
    this.menu.isActive = false;
    console.log({
      language: this.selectedLanguages,
      service: this.selectedServices,
      minPrice: this.typedMinPrice,
      maxPrice: this.typedMaxPrice
    })
    return {
      language: this.selectedLanguages,
      service: this.selectedServices,
      minPrice: this.typedMinPrice,
      maxPrice: this.typedMaxPrice
    }
  }

  @Emit() clear() {
    this.selectedServices = this.selectedServices = [];
    this.typedMinPrice = this.typedMaxPrice = '';
    this.apply();
  }

  private selectedLanguages: FilterSelectOption[] = [];
  private selectedServices: FilterSelectOption[] = [];
  private typedMinPrice: any = '';
  private typedMaxPrice: any = '';

  activatorClicked() {
  }

  on: boolean = false;
}
